export default __webpack_public_path__ + "static/media/logo.7c41c1b5.svg";